module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('analysis-chart', {
    attrs: {
      "type": "monthly",
      "path": "connectionanalysis",
      "title": "Device Connection Counts (Last Year)"
    }
  }), _vm._v(" "), _c('analysis-chart', {
    attrs: {
      "type": "deviceid",
      "path": "deviceconnectcountsanalysis",
      "title": "Device Connection Counts"
    }
  }), _vm._v(" "), _c('analysis-chart', {
    attrs: {
      "type": "daily",
      "path": "dailyactivationanalysis",
      "title": "Device Daily Activation Counts (Last 30 Days)"
    }
  }), _vm._v(" "), _c('analysis-chart', {
    attrs: {
      "type": "monthly",
      "path": "monthlyactivationanalysis",
      "title": "Device Monthly Activation Counts (Last Year)"
    }
  }), _vm._v(" "), _c('analysis-chart', {
    attrs: {
      "type": "duration",
      "path": "disconnectdurationanalysis",
      "title": "Device Disconnect Durations"
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "callout callout-info"
  }, [_c('h4', [_vm._v("Analysis")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-80fb67d4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-80fb67d4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/ConnectionAnalysis.vue
// module id = 488
// module chunks = 1